import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1696fdec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body py-4" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-4 fixHeightScroll" }
const _hoisted_6 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Collection of Minimum KYC Information ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 mb-5" }
const _hoisted_12 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_13 = { class: "col-lg-6 mb-5" }
const _hoisted_14 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_15 = { class: "col-lg-6 mb-5" }
const _hoisted_16 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_17 = { class: "col-lg-6 mb-5" }
const _hoisted_18 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_19 = { class: "col-lg-12 mb-5" }
const _hoisted_20 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_21 = { class: "col-6 mb-5" }
const _hoisted_22 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_23 = { class: "col-6 mb-5" }
const _hoisted_24 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_25 = { class: "col-6 mb-5" }
const _hoisted_26 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_27 = { class: "col-6 mb-5" }
const _hoisted_28 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_29 = {
  key: 0,
  class: "col-12 mb-5"
}
const _hoisted_30 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_31 = {
  key: 1,
  class: "col-12 mb-5"
}
const _hoisted_32 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_33 = { class: "form-label fs-6 fw-bold text-dark required mt-7" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_35 = {
  key: 2,
  class: "col-12 mb-5"
}
const _hoisted_36 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_37 = {
  key: 3,
  class: "col-12 mb-5"
}
const _hoisted_38 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_39 = {
  key: 4,
  class: "col-12 mb-5"
}
const _hoisted_40 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_41 = {
  key: 5,
  class: "col-12 mb-5"
}
const _hoisted_42 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_43 = { class: "form-label fs-6 fw-bold text-dark required mt-7" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_45 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_46 = {
  class: "form-label fs-6 fw-bold text-dark",
  style: {"width":"130px"}
}
const _hoisted_47 = {
  class: "w-100 my-5 card verify-card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = { class: "pb-3" }
const _hoisted_50 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-lg-12 mb-5" }
const _hoisted_54 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-6 col-lg-2" }
const _hoisted_57 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg1_yes"
}
const _hoisted_58 = { class: "d-block fw-semobold text-start" }
const _hoisted_59 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_60 = { class: "col-6 col-lg-2" }
const _hoisted_61 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg1_no"
}
const _hoisted_62 = { class: "d-block fw-semobold text-start" }
const _hoisted_63 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_64 = { class: "col-lg-12 mb-5" }
const _hoisted_65 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-6 col-lg-2" }
const _hoisted_68 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg2_yes"
}
const _hoisted_69 = { class: "d-block fw-semobold text-start" }
const _hoisted_70 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_71 = { class: "col-6 col-lg-2" }
const _hoisted_72 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "bg2_no"
}
const _hoisted_73 = { class: "d-block fw-semobold text-start" }
const _hoisted_74 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_75 = {
  class: "w-100 card verify-card my-5",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_76 = { class: "card-body" }
const _hoisted_77 = { class: "pb-3" }
const _hoisted_78 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-lg-12 mb-5" }
const _hoisted_82 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-6 col-lg-2" }
const _hoisted_85 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "exp1_true"
}
const _hoisted_86 = { class: "d-block fw-semobold text-start" }
const _hoisted_87 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_88 = { class: "col-6 col-lg-2" }
const _hoisted_89 = {
  class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
  for: "exp1_false"
}
const _hoisted_90 = { class: "d-block fw-semobold text-start" }
const _hoisted_91 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_92 = {
  key: 0,
  class: "col-lg-12 mb-5"
}
const _hoisted_93 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_94 = {
  key: 1,
  class: "col-lg-12 mb-5"
}
const _hoisted_95 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_96 = {
  key: 2,
  class: "col-lg-12 mb-5"
}
const _hoisted_97 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_98 = { class: "form-label fw-bold text-dark fs-6 required" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-6 col-lg-2" }
const _hoisted_101 = ["for"]
const _hoisted_102 = { class: "d-block fw-semobold text-start" }
const _hoisted_103 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_104 = { class: "col-6 col-lg-2" }
const _hoisted_105 = ["for"]
const _hoisted_106 = { class: "d-block fw-semobold text-start" }
const _hoisted_107 = { class: "fw-bold d-block fs-4 mb-2" }
const _hoisted_108 = {
  key: 0,
  class: "col-lg-12 mt-10 ms-3"
}
const _hoisted_109 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_110 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_111 = { class: "card-body" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " For Sole Trader Only ")
], -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_114 = { class: "row" }
const _hoisted_115 = { class: "col-lg-6 mb-5" }
const _hoisted_116 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_117 = { class: "col-lg-6 mb-5" }
const _hoisted_118 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_119 = { class: "col-lg-12 mb-5" }
const _hoisted_120 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_121 = { class: "col-lg-6 mb-5" }
const _hoisted_122 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_123 = { class: "col-lg-6 mb-5" }
const _hoisted_124 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_125 = { class: "col-lg-6 mb-5" }
const _hoisted_126 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_127 = { class: "col-lg-6 mb-5" }
const _hoisted_128 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_129 = { class: "col-lg-12 mb-5" }
const _hoisted_130 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_131 = { class: "col-lg-12 mb-5" }
const _hoisted_132 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_133 = { class: "col-lg-12 mb-5" }
const _hoisted_134 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_135 = { class: "col-lg-12 mb-5" }
const _hoisted_136 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_137 = { class: "col-lg-12 mb-5" }
const _hoisted_138 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_139 = { class: "col-lg-12 mb-5" }
const _hoisted_140 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_141 = { class: "col-lg-12 mb-5" }
const _hoisted_142 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_143 = {
  class: "w-100 card my-5",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_144 = { class: "card-body" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Verification ")
], -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_147 = { class: "row" }
const _hoisted_148 = { class: "col-6 mb-5" }
const _hoisted_149 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_150 = { class: "col-lg-6 mb-5" }
const _hoisted_151 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_152 = { class: "col-lg-6 mb-5" }
const _hoisted_153 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_154 = { class: "col-lg-6 mb-5" }
const _hoisted_155 = { class: "form-label fs-6 fw-bold text-dark" }
const _hoisted_156 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_157 = { class: "card-body" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark ms-3" }, " Admin Use Only ")
], -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "col-lg-6 mb-5" }
const _hoisted_162 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_163 = { class: "col-lg-6 mb-5" }
const _hoisted_164 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_165 = { class: "col-lg-6 mb-5" }
const _hoisted_166 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_167 = { class: "col-lg-6 mb-5" }
const _hoisted_168 = { class: "form-label fs-6 fw-bold text-dark required" }
const _hoisted_169 = {
  class: "w-100 my-5 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_170 = { class: "card-body d-flex justify-content-center" }
const _hoisted_171 = { class: "col-8 fixHeightScroll" }
const _hoisted_172 = {
  class: "w-100 card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_173 = { class: "card-body" }

import { useI18n } from "vue-i18n";
import { Field } from "vee-validate";
import { ref, onMounted, computed } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import previewKycForm from "./PreviewKycForm.vue";
import SignatureModal from "./SignatureModal.vue";
import { VerificationStatusTypes } from "@/core/types/VerificationInfos";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserKycForm',
  props: {
    selectedPartyId: {}
  },
  emits: ["fetchData", "returnTable"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const signatureModalRef = ref<InstanceType<typeof SignatureModal>>();

const { t } = useI18n();

const isLoading = ref(true);
const kycInfos = ref({} as any);

const show_exp1_more = ref(false);
const trading_exp = computed(() => ({
  exp2: {
    id: "exp2",
    text: t("tip.verificationFinancialHaveBankruptcy"),
    show_more: false,
    more_question: t("tip.verificationFinancialIndicateDischarge"),
  },
  exp3: {
    id: "exp3",
    text: t("tip.verificationFinancialAnyPersonOfCommodityOrRegulatory"),
    show_more: false,
    more_question: t("tip.verificationFinancialProvideExchangeOrAgency"),
  },
  exp4: {
    id: "exp4",
    text: t("tip.verificationFinancialAreYouPep"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
  exp5: {
    id: "exp5",
    text: t("tip.verificationFinancialAreYouAssociate"),
    show_more: false,
    more_question: t("tip.yesProvideDetails"),
  },
}));

const funds = computed(() => ({
  fund_1: {
    id: "fund_1",
    text: t("fields.employment"),
    value: "employment",
  },
  fund_2: {
    id: "fund_2",
    text: t("fields.inheritance"),
    value: "inheritance",
  },
  fund_3: {
    id: "fund_3",
    text: t("fields.savingAndInvestment"),
    value: "saving_and_investment",
  },
  fund_4: {
    id: "fund_4",
    text: t("fields.other"),
    value: "other",
  },
}));

const funds2 = computed(() => ({
  fund1: {
    id: "fund1",
    text: t("type.verification.financial.fund1"), // Salary or employment income
    value: "fund1",
  },
  fund2: {
    id: "fund2",
    text: t("type.verification.financial.fund2"), // Business income
    value: "fund2",
  },
  fund3: {
    id: "fund3",
    text: t("type.verification.financial.fund3"), // Investment income
    value: "fund3",
  },
  fund4: {
    id: "fund4",
    text: t("type.verification.financial.fund4"), // Sale of property or other assets
    value: "fund4",
  },
  fund5: {
    id: "fund5",
    text: t("type.verification.financial.fund5"), // Inheritance or family wealth
    value: "fund5",
  },
  fund6: {
    id: "fund6",
    text: t("type.verification.financial.fund6"), // Savings accumulated over time
    value: "fund6",
  },
  fund7: {
    id: "fund7",
    text: t("type.verification.financial.fund7"), // Pension or retirement income
    value: "fund7",
  },
  fund8: {
    id: "fund8",
    text: t("type.verification.financial.fund8"), // Loan or credit facility
    value: "fund8",
  },
  fund9: {
    id: "fund9",
    text: t("type.verification.financial.fund9"), // Gift from family or third party
    value: "fund9",
  },
}));

const natureOfTransactions = computed(() => ({
  txn1: { id: "txn1", text: t("type.verification.nature.txn1"), value: "txn1" }, // Spot FOREX trading
  txn2: { id: "txn2", text: t("type.verification.nature.txn2"), value: "txn2" }, // CFDs on indices, commodities, shares
  txn3: { id: "txn3", text: t("type.verification.nature.txn3"), value: "txn3" }, // Precious metals trading
  txn4: { id: "txn4", text: t("type.verification.nature.txn4"), value: "txn4" }, // Margin/leveraged transactions
  txn5: { id: "txn5", text: t("type.verification.nature.txn5"), value: "txn5" }, // Hedging / risk management
  txn6: { id: "txn6", text: t("type.verification.nature.txn6"), value: "txn6" }, // Short-term speculative trading
  txn7: { id: "txn7", text: t("type.verification.nature.txn7"), value: "txn7" }, // Long-term investment trading
}));

const expectedAvgTradeSizes = computed(() => ({
  size1: {
    id: "size1",
    text: t("type.verification.expected.size1"),
    value: "size1",
  }, // < 5k
  size2: {
    id: "size2",
    text: t("type.verification.expected.size2"),
    value: "size2",
  }, // 5,001–25k
  size3: {
    id: "size3",
    text: t("type.verification.expected.size3"),
    value: "size3",
  }, // 25,001–100k
  size4: {
    id: "size4",
    text: t("type.verification.expected.size4"),
    value: "size4",
  }, // > 100k
}));

const expectedMonthlyVolume = computed(() => ({
  vol1: {
    id: "vol1",
    text: t("type.verification.expected.vol1"),
    value: "vol1",
  }, // < 10k
  vol2: {
    id: "vol2",
    text: t("type.verification.expected.vol2"),
    value: "vol2",
  }, // 10,001–50k
  vol3: {
    id: "vol3",
    text: t("type.verification.expected.vol3"),
    value: "vol3",
  }, // 50,001–250k
  vol4: {
    id: "vol4",
    text: t("type.verification.expected.vol4"),
    value: "vol4",
  }, // 250,001–1,000,000
  vol5: {
    id: "vol5",
    text: t("type.verification.expected.vol5"),
    value: "vol5",
  }, // > 1,000,000
}));

const expectedFrequency = computed(() => ({
  freq1: {
    id: "freq1",
    text: t("type.verification.expected.freq1"),
    value: "freq1",
  }, // Occasional
  freq2: {
    id: "freq2",
    text: t("type.verification.expected.freq2"),
    value: "freq2",
  }, // Moderate
  freq3: {
    id: "freq3",
    text: t("type.verification.expected.freq3"),
    value: "freq3",
  }, // Frequent
}));

const loadUserKycInfo = async () => {
  isLoading.value = true;
  try {
    kycInfos.value = await UserService.getPredefinedKycInfos(
      props.selectedPartyId
    );
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const openSignaturePanel = () => {
  signatureModalRef.value?.show();
};

const handelSignature = (_signature) => {
  kycInfos.value.staffSignature = _signature;
  signatureModalRef.value?.hide();
  signatureModalRef.value?.clear();
};

const returnTable = () => {
  emits("returnTable");
};

const submitKycForm = async (_op: string) => {
  try {
    if (_op == "update") {
      await UserService.putKycForm(props.selectedPartyId, kycInfos.value);
      MsgPrompt.success(t("tip.updateSuccess")).then(() => {
        emits("fetchData", 1);
      });
    } else {
      await UserService.signKycForm(props.selectedPartyId, kycInfos.value);
      MsgPrompt.success(t("tip.submitSuccess")).then(() => {
        emits("fetchData", 1);
      });
    }
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  loadUserKycInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { class: "d-flex justify-content-end" }, [
      _createElementVNode("button", {
        class: "btn btn-light btn-success btn-md me-3",
        onClick: returnTable,
        style: {"margin-top":"-65px","height":"45px"}
      }, " Return ")
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("table", null, [
                _createElementVNode("tbody", null, [
                  _createVNode(_component_LoadingRing)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("fields.firstName")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.firstName,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "firstName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.firstName,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((kycInfos.value.firstName) = $event)),
                              name: "firstName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("fields.lastName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.lastName,
                          tabindex: "2",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "lastName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.lastName,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((kycInfos.value.lastName) = $event)),
                              name: "lastName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("fields.priorName")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.priorName,
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "priorName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.priorName,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((kycInfos.value.priorName) = $event)),
                              name: "priorName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.birthdate")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.birthday,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "birthday",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.birthday,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((kycInfos.value.birthday) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.address")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.address,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((kycInfos.value.address) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "address",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.address,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((kycInfos.value.address) = $event)),
                              name: "address",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("fields.industry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.industry,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((kycInfos.value.industry) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "industry"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.industry,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((kycInfos.value.industry) = $event)),
                              name: "industry",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "government",
                                  label: _ctx.$t('fields.government')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "accounting",
                                  label: _ctx.$t('fields.accounting')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "banking",
                                  label: _ctx.$t('fields.banking')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "finance",
                                  label: _ctx.$t('fields.finance')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "insurance",
                                  label: _ctx.$t('fields.insurance')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "other",
                                  label: _ctx.$t('fields.other')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("fields.position")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.occupation,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "position"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.occupation,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((kycInfos.value.occupation) = $event)),
                              name: "position",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "director",
                                  label: _ctx.$t('fields.director')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "manager",
                                  label: _ctx.$t('fields.manager')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "entry_level",
                                  label: _ctx.$t('fields.entryLevel')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "other",
                                  label: _ctx.$t('fields.other')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("fields.annualIncome")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.annualIncome,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((kycInfos.value.annualIncome) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "income"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.annualIncome,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((kycInfos.value.annualIncome) = $event)),
                              name: "income",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "1",
                                  label: _ctx.$t('fields.range_1')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "2",
                                  label: _ctx.$t('fields.range_1')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "3",
                                  label: _ctx.$t('fields.range_2')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "4",
                                  label: _ctx.$t('fields.range_3')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "5",
                                  label: _ctx.$t('fields.range_4')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "6",
                                  label: _ctx.$t('fields.range_5')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("fields.savingsAndInvestments")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.netWorth,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((kycInfos.value.netWorth) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "investment"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.netWorth,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((kycInfos.value.netWorth) = $event)),
                              name: "investment",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: "1",
                                  label: _ctx.$t('fields.range_1')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "2",
                                  label: _ctx.$t('fields.range_2')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "3",
                                  label: _ctx.$t('fields.range_3')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "4",
                                  label: _ctx.$t('fields.range_4')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "5",
                                  label: _ctx.$t('fields.range_5')
                                }, null, 8, ["label"]),
                                _createVNode(_component_el_option, {
                                  value: "6",
                                  label: _ctx.$t('fields.range_6')
                                }, null, 8, ["label"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      (kycInfos.value.sourceOfFunds !== '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("fields.howToFundTrading")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.sourceOfFunds,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((kycInfos.value.sourceOfFunds) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "sourceOfFunds",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.sourceOfFunds,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((kycInfos.value.sourceOfFunds) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "sourceOfFunds",
                                  autocomplete: "off",
                                  size: "large"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (kycInfos.value.fund2 !== '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("fields.howToFundTrading")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.fund2,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((kycInfos.value.fund2) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "fund2",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.fund2,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((kycInfos.value.fund2) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "fund2",
                                  autocomplete: "off",
                                  size: "large"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("fields.expectedNatureAndLevelOfTransactions")), 1),
                      _hoisted_34,
                      (kycInfos.value.nature !== '' && kycInfos.value.nature !== null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("fields.natureOfTransactions")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.nature,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((kycInfos.value.nature) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "nature",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.nature,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((kycInfos.value.nature) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "nature",
                                  autocomplete: "off",
                                  size: "large"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    kycInfos.value.transaction1 !== '' &&
                    kycInfos.value.transaction1 !== null
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("fields.averageTradeSize")), 1),
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.transaction1,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((kycInfos.value.transaction1) = $event)),
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedAvgTradeSizes.value, (pos) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: pos.id,
                                    value: pos.value,
                                    label: pos.text,
                                    border: ""
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    kycInfos.value.transaction2 !== '' &&
                    kycInfos.value.transaction2 !== null
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t("fields.expectedMonthlyTradeVolume")), 1),
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.transaction2,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((kycInfos.value.transaction2) = $event)),
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedMonthlyVolume.value, (pos) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: pos.id,
                                    value: pos.value,
                                    label: pos.text,
                                    border: ""
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    kycInfos.value.transaction3 !== '' &&
                    kycInfos.value.transaction3 !== null
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t("fields.expectedFrequencyOfTransactions")), 1),
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.transaction3,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((kycInfos.value.transaction3) = $event)),
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedFrequency.value, (pos) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: pos.id,
                                    value: pos.value,
                                    label: pos.text,
                                    border: ""
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("title.socialMedia")), 1),
                      _hoisted_44,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kycInfos.value.socialMediaTypes, (type, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12 mb-3",
                          key: index
                        }, [
                          (type.account != '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("fields." + type.name)), 1),
                                _createVNode(_component_el_input, {
                                  modelValue: type.account,
                                  "onUpdate:modelValue": ($event: any) => ((type.account) = $event),
                                  tabindex: "2",
                                  type: "text",
                                  name: type.name,
                                  autocomplete: "off",
                                  size: "large",
                                  disabled: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("h2", _hoisted_50, _toDisplayString(_ctx.$t("title.tradingBackground")), 1)
                    ]),
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("tip.haveYouEverAttendedAnEducationSeminar")), 1),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.bg1,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((kycInfos.value.bg1) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "bg1",
                              value: "0",
                              id: "bg1_yes"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_57, [
                              _createElementVNode("span", _hoisted_58, [
                                _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("action.yes")), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.bg1,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((kycInfos.value.bg1) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "bg1",
                              value: "1",
                              id: "bg1_no"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_61, [
                              _createElementVNode("span", _hoisted_62, [
                                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("action.no")), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("tip.previousExperienceTradingStockBondsCFD")), 1),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.bg2,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((kycInfos.value.bg2) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "bg2",
                              value: "0",
                              id: "bg2_yes"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_68, [
                              _createElementVNode("span", _hoisted_69, [
                                _createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.$t("action.yes")), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_71, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.bg2,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((kycInfos.value.bg2) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "bg2",
                              value: "1",
                              id: "bg2_no"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_72, [
                              _createElementVNode("span", _hoisted_73, [
                                _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.$t("action.no")), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("h2", _hoisted_78, _toDisplayString(_ctx.$t("title.relevantTradingExperience")), 1)
                    ]),
                    _hoisted_79,
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("tip.verificationFinancialAreYouBcrEmployee")), 1),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.exp1,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((kycInfos.value.exp1) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "exp1",
                              value: "0",
                              id: "exp1_true",
                              onClick: _cache[30] || (_cache[30] = ($event: any) => (show_exp1_more.value = true))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_85, [
                              _createElementVNode("span", _hoisted_86, [
                                _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.$t("action.yes")), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.exp1,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((kycInfos.value.exp1) = $event)),
                              type: "radio",
                              class: "btn-check",
                              name: "exp1",
                              value: "1",
                              id: "exp1_false",
                              onClick: _cache[32] || (_cache[32] = ($event: any) => (show_exp1_more.value = false))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_89, [
                              _createElementVNode("span", _hoisted_90, [
                                _createElementVNode("span", _hoisted_91, _toDisplayString(_ctx.$t("action.no")), 1)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      (show_exp1_more.value || kycInfos.value.exp1 == '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t("fields.employer")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.exp1Employer,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((kycInfos.value.exp1Employer) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "exp1Employer",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.exp1Employer,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((kycInfos.value.exp1Employer) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "exp1Employer",
                                  size: "large",
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (show_exp1_more.value || kycInfos.value.exp1 == '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                            _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("fields.position")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.exp1Position,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((kycInfos.value.exp1Position) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "exp1Position",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.exp1Position,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((kycInfos.value.exp1Position) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "exp1Position",
                                  autocomplete: "off",
                                  size: "large"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (show_exp1_more.value || kycInfos.value.exp1 == '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                            _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.$t("fields.remuneration")), 1),
                            _createVNode(_unref(Field), {
                              modelValue: kycInfos.value.exp1Remuneration,
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((kycInfos.value.exp1Remuneration) = $event)),
                              tabindex: "2",
                              type: "text",
                              name: "exp1Remuneration",
                              autocomplete: "off"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: kycInfos.value.exp1Remuneration,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((kycInfos.value.exp1Remuneration) = $event)),
                                  tabindex: "2",
                                  type: "text",
                                  name: "exp1Remuneration",
                                  autocomplete: "off",
                                  size: "large"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trading_exp.value, (v_item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-lg-12 mb-5"
                        }, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(v_item.text), 1),
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_unref(Field), {
                                modelValue: kycInfos.value[v_item.id],
                                "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id]) = $event),
                                type: "radio",
                                class: "btn-check",
                                name: v_item.id,
                                value: "0",
                                id: v_item.id + '_true',
                                onClick: ($event: any) => (v_item.show_more = true)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                              _createElementVNode("label", {
                                class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                                for: v_item.id + '_true'
                              }, [
                                _createElementVNode("span", _hoisted_102, [
                                  _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.$t("action.yes")), 1)
                                ])
                              ], 8, _hoisted_101)
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createVNode(_unref(Field), {
                                modelValue: kycInfos.value[v_item.id],
                                "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id]) = $event),
                                type: "radio",
                                class: "btn-check",
                                name: v_item.id,
                                value: "1",
                                id: v_item.id + '_false',
                                onClick: ($event: any) => (v_item.show_more = false)
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "id", "onClick"]),
                              _createElementVNode("label", {
                                class: "btn btn-outline btn-outline-default p-3 d-flex align-items-center",
                                for: v_item.id + '_false'
                              }, [
                                _createElementVNode("span", _hoisted_106, [
                                  _createElementVNode("span", _hoisted_107, _toDisplayString(_ctx.$t("action.no")), 1)
                                ])
                              ], 8, _hoisted_105)
                            ])
                          ]),
                          (v_item.show_more || kycInfos.value[v_item.id] == '0')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                _createElementVNode("label", _hoisted_109, _toDisplayString(v_item.more_question), 1),
                                _createVNode(_unref(Field), {
                                  modelValue: kycInfos.value[v_item.id + 'More'],
                                  "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id + 'More']) = $event),
                                  tabindex: "2",
                                  type: "text",
                                  name: v_item.id + 'More',
                                  autocomplete: "off"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: kycInfos.value[v_item.id + 'More'],
                                      "onUpdate:modelValue": ($event: any) => ((kycInfos.value[v_item.id + 'More']) = $event),
                                      tabindex: "2",
                                      type: "text",
                                      name: v_item.id + 'More',
                                      autocomplete: "off",
                                      size: "large"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _hoisted_112,
                    _hoisted_113,
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t("fields.businessName")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessName,
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((kycInfos.value.businessName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessName,
                              "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((kycInfos.value.businessName) = $event)),
                              name: "businessName",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("label", _hoisted_118, _toDisplayString(_ctx.$t("fields.businessNumber")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.businessNumber,
                          tabindex: "2",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessNumber,
                              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((kycInfos.value.businessNumber) = $event)),
                              name: "businessNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.$t("fields.businessAddress")), 1),
                        _createVNode(_unref(Field), {
                          value: kycInfos.value.businessAddress,
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessAddress",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessAddress,
                              "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((kycInfos.value.businessAddress) = $event)),
                              name: "businessAddress",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t("fields.businessCity")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCity,
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((kycInfos.value.businessCity) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCity",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCity,
                              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((kycInfos.value.businessCity) = $event)),
                              name: "businessCity",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_123, [
                        _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("fields.businessState")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessState,
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((kycInfos.value.businessState) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessState",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessState,
                              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((kycInfos.value.businessState) = $event)),
                              name: "businessState",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.$t("fields.businessZipCode")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessZipCode,
                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((kycInfos.value.businessZipCode) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessZipCode",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessZipCode,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((kycInfos.value.businessZipCode) = $event)),
                              name: "businessZipCode",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t("fields.businessCountry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCountry,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((kycInfos.value.businessCountry) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCountry",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCountry,
                              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((kycInfos.value.businessCountry) = $event)),
                              name: "businessCountry",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.$t("fields.businessCompanyPurposeBetweenUs")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessCompanyPurposeBetweenUs,
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((kycInfos.value.businessCompanyPurposeBetweenUs) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessCompanyPurposeBetweenUs",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessCompanyPurposeBetweenUs,
                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((kycInfos.value.businessCompanyPurposeBetweenUs) = $event)),
                              name: "businessCompanyPurposeBetweenUs",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_131, [
                        _createElementVNode("label", _hoisted_132, _toDisplayString(_ctx.$t("fields.businessServiceRequireReason")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessServiceRequireReason,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((kycInfos.value.businessServiceRequireReason) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessServiceRequireReason",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessServiceRequireReason,
                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((kycInfos.value.businessServiceRequireReason) = $event)),
                              name: "businessServiceRequireReason",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("label", _hoisted_134, _toDisplayString(_ctx.$t("fields.businessIndustry")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessIndustry,
                          "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((kycInfos.value.businessIndustry) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessIndustry",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessIndustry,
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((kycInfos.value.businessIndustry) = $event)),
                              name: "businessIndustry",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("label", _hoisted_136, _toDisplayString(_ctx.$t("fields.businessClientIndustry1")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry1,
                          "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((kycInfos.value.businessClientIndustry1) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry1",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry1,
                              "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((kycInfos.value.businessClientIndustry1) = $event)),
                              name: "businessClientIndustry1",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t("fields.businessClientIndustry2")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry2,
                          "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((kycInfos.value.businessClientIndustry2) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry2",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry2,
                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((kycInfos.value.businessClientIndustry2) = $event)),
                              name: "businessClientIndustry2",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("label", _hoisted_140, _toDisplayString(_ctx.$t("fields.businessClientIndustry3")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessClientIndustry3,
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((kycInfos.value.businessClientIndustry3) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessClientIndustry3",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessClientIndustry3,
                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((kycInfos.value.businessClientIndustry3) = $event)),
                              name: "businessClientIndustry3",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t("fields.businessService")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.businessService,
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((kycInfos.value.businessService) = $event)),
                          tabindex: "8",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "businessService",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.businessService,
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((kycInfos.value.businessService) = $event)),
                              name: "businessService",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_143, [
                  _createElementVNode("div", _hoisted_144, [
                    _hoisted_145,
                    _hoisted_146,
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, [
                        _createElementVNode("label", _hoisted_149, _toDisplayString(_ctx.$t("fields.formId")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idType,
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((kycInfos.value.idType) = $event)),
                          tabindex: "3",
                          class: "form-control form-control-lg form-control-solid",
                          name: "idType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: kycInfos.value.idType,
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((kycInfos.value.idType) = $event)),
                              name: "idType",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: 1,
                                  label: "Government ID"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 2,
                                  label: "Driver's License"
                                }),
                                _createVNode(_component_el_option, {
                                  value: 3,
                                  label: "Passport"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("label", _hoisted_151, _toDisplayString(_ctx.$t("fields.doc_number")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idNumber,
                          "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idNumber",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.idNumber,
                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((kycInfos.value.idNumber) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t("fields.issue_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idIssuedOn,
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idIssuedOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idIssuedOn,
                              "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((kycInfos.value.idIssuedOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("label", _hoisted_155, _toDisplayString(_ctx.$t("fields.expire_date")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.idExpireOn,
                          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "idExpireOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.idExpireOn,
                              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((kycInfos.value.idExpireOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_156, [
                  _createElementVNode("div", _hoisted_157, [
                    _hoisted_158,
                    _hoisted_159,
                    _createElementVNode("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("label", _hoisted_162, _toDisplayString(_ctx.$t("fields.adminStaffMember")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffName,
                          "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((kycInfos.value.staffName) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffName",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.staffName,
                              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((kycInfos.value.staffName) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_163, [
                        _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.$t("fields.adminStaffPosition")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffPosition,
                          "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((kycInfos.value.staffPosition) = $event)),
                          tabindex: "1",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffPosition",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: kycInfos.value.staffPosition,
                              "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((kycInfos.value.staffPosition) = $event)),
                              name: "idNumber",
                              size: "large"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_165, [
                        _createElementVNode("label", _hoisted_166, _toDisplayString(_ctx.$t("fields.signDate")), 1),
                        _createVNode(_unref(Field), {
                          modelValue: kycInfos.value.staffSignedOn,
                          "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((kycInfos.value.staffSignedOn) = $event)),
                          tabindex: "4",
                          class: "form-control form-control-lg form-control-solid",
                          type: "text",
                          name: "staffSignedOn",
                          autocomplete: "off"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: kycInfos.value.staffSignedOn,
                              "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((kycInfos.value.staffSignedOn) = $event)),
                              type: "date",
                              size: "large",
                              "value-format": "YYYY-MM-DD"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("label", _hoisted_168, _toDisplayString(_ctx.$t("action.sign")), 1),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            class: "btn btn-light btn-success btn-sm me-3",
                            style: {"width":"100%","height":"40px"},
                            onClick: openSignaturePanel
                          }, _toDisplayString(_ctx.$t("action.sign")), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _createElementVNode("div", _hoisted_170, [
                    _createElementVNode("button", {
                      class: "btn btn-light btn-primary btn-lg me-3",
                      onClick: _cache[79] || (_cache[79] = ($event: any) => (submitKycForm('update')))
                    }, _toDisplayString(_ctx.$t("action.update")), 1),
                    _createElementVNode("button", {
                      class: "btn btn-light btn-warning btn-lg me-3",
                      onClick: _cache[80] || (_cache[80] = ($event: any) => (submitKycForm('submit')))
                    }, _toDisplayString(_ctx.$t("action.submit")), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_171, [
                _createElementVNode("div", _hoisted_172, [
                  _createElementVNode("div", _hoisted_173, [
                    _createVNode(previewKycForm, { kycInfos: kycInfos.value }, null, 8, ["kycInfos"])
                  ])
                ])
              ])
            ]))
      ]),
      _createVNode(SignatureModal, {
        ref_key: "signatureModalRef",
        ref: signatureModalRef,
        onHandelSignature: handelSignature
      }, null, 512)
    ])
  ], 64))
}
}

})